/* Photos portées du fabricant : grande vue dans un <dialog> (chantier C8, 22/10/2026). Les vignettes sont des liens
   vers la grande photo : sans ce script, elles l'ouvrent simplement.
   Délégation sur le document : le bloc peut être remplacé par Dawn au changement de variante, rien à réattacher.
   Flèches gauche / droite pour changer de photo, Échap ou clic sur le fond pour fermer (le focus revient à la vignette). */
(function () {
  if (window.__askMq) return;
  window.__askMq = true;

  // vignettes encore affichées (une photo qui ne charge pas retire sa vignette : onerror dans le snippet)
  function vignettes(racine) {
    return Array.prototype.slice.call(racine.querySelectorAll('.ask-mq__vig')).filter(function (v) {
      var li = v.closest('li');
      return !(li && li.hidden);
    });
  }

  // texte lu par les lecteurs d'écran (« Agrandir la photo 2 sur 4 ») recalculé quand une vignette a été retirée
  function renumeroter(racine) {
    var vs = vignettes(racine);
    vs.forEach(function (v, i) {
      var c = v.querySelector('.ask-cache');
      if (c) c.textContent = 'Agrandir la photo ' + (i + 1) + ' sur ' + vs.length + ' : ';
    });
  }
  function retirer(img) {
    var li = img.closest('li');
    var racine = img.closest('[data-ask-mq]');
    if (li) li.hidden = true;
    if (racine) renumeroter(racine);
  }
  // vignettes déjà retirées par leur onerror avant le chargement de ce script (différé), puis celles qui échoueront plus
  // tard (chargement différé des images). On ne teste pas img.complete : certains navigateurs le disent vrai pour une
  // image différée pas encore demandée, ce qui retirerait une bonne photo.
  Array.prototype.forEach.call(document.querySelectorAll('[data-ask-mq]'), function (racine) {
    if (racine.querySelector('.ask-mq__rang > li[hidden]')) renumeroter(racine);
  });
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.closest && t.closest('.ask-mq__vig')) retirer(t);
  }, true);

  function montrer(racine, i) {
    var vs = vignettes(racine);
    if (!vs.length) return;
    i = (i + vs.length) % vs.length;
    var v = vs[i];
    var d = racine.querySelector('.ask-mq__d');
    var img = d.querySelector('.ask-mq__d-img');
    var vImg = v.querySelector('img');
    var haut = parseInt(v.getAttribute('data-haut'), 10) || 1500;
    d.setAttribute('data-i', String(i));
    img.removeAttribute('srcset');
    img.setAttribute('height', String(haut));
    img.setAttribute('width', '1000');
    // vignette déjà chargée en fond pendant le chargement de la grande photo
    img.style.backgroundImage = vImg && vImg.currentSrc ? 'url("' + vImg.currentSrc + '")' : '';
    img.style.backgroundSize = 'contain';
    img.style.backgroundPosition = 'center';
    img.style.backgroundRepeat = 'no-repeat';
    var srcset = v.getAttribute('data-grand-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.src = v.getAttribute('data-grand');
    img.alt = vImg ? vImg.alt : '';
    var leg = d.querySelector('[data-ask-mq-legende]');
    var cpt = d.querySelector('[data-ask-mq-compte]');
    if (leg) leg.textContent = vImg ? vImg.alt : '';
    if (cpt) cpt.textContent = 'Photo du fabricant · ' + (i + 1) + ' / ' + vs.length;
    img.onload = function () { img.style.backgroundImage = ''; };
    // grande photo introuvable : on montre la vignette déjà chargée, en plus petit, plutôt qu'une image cassée
    img.onerror = function () {
      img.onerror = null;
      if (vImg && vImg.currentSrc) { img.removeAttribute('srcset'); img.src = vImg.currentSrc; }
    };
  }

  document.addEventListener('click', function (e) {
    var cible = e.target;
    var vig = cible.closest && cible.closest('.ask-mq__vig');
    if (vig) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return; // ouverture voulue dans un autre onglet
      var racine = vig.closest('[data-ask-mq]');
      var d = racine && racine.querySelector('.ask-mq__d');
      if (!d || typeof d.showModal !== 'function') return; // très vieux navigateur : le lien ouvre la photo seule
      e.preventDefault();
      montrer(racine, vignettes(racine).indexOf(vig));
      // vraie barre de défilement à l'écran (Windows) : sa place reste réservée pendant que la page est bloquée (CSS)
      var html = document.documentElement;
      html.classList.toggle('ask-mq-gouttiere', window.innerWidth - html.clientWidth > 0);
      if (!d.open) d.showModal();
      return;
    }
    var d2 = cible.closest && cible.closest('.ask-mq__d');
    if (!d2) return;
    if (cible === d2) { d2.close(); return; } // clic sur le fond (hors du cadre)
    if (cible.closest('[data-ask-mq-fermer]')) { d2.close(); return; }
    var pas = cible.closest('[data-ask-mq-pas]');
    if (pas) montrer(d2.closest('[data-ask-mq]'), (parseInt(d2.getAttribute('data-i'), 10) || 0) + parseInt(pas.getAttribute('data-ask-mq-pas'), 10));
  });

  /* E3 (v3.1, 23/10/2026) : fiche technique en aperçu sur place. Tout bouton [data-ask-ft-ouvrir="AskFt-…"] (ligne sous les
     photos portées, accordéon « Guide des tailles ») ouvre la fenêtre ; ses pages (images) ne se chargent qu'à ce moment-là.
     Fermeture : bouton, Échap (natif) ou clic sur le fond ; le navigateur rend le focus au bouton d'ouverture. */
  function ouvrirFiche(bouton) {
    var d = document.getElementById(bouton.getAttribute('data-ask-ft-ouvrir'));
    if (!d || typeof d.showModal !== 'function') return false;
    Array.prototype.forEach.call(d.querySelectorAll('img[data-src]'), function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
    var html = document.documentElement;
    html.classList.toggle('ask-mq-gouttiere', window.innerWidth - html.clientWidth > 0);
    if (!d.open) d.showModal();
    var pages = d.querySelector('.ask-ft__pages');
    if (pages) pages.scrollTop = 0;
    return true;
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest && t.closest('[data-ask-ft-ouvrir]');
    if (b) { if (ouvrirFiche(b)) e.preventDefault(); return; }
    var d = t.closest && t.closest('.ask-ft');
    if (!d) return;
    if (t === d || t.closest('[data-ask-ft-fermer]')) d.close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var d = document.querySelector('.ask-mq__d[open]');
    if (!d) return;
    e.preventDefault();
    montrer(d.closest('[data-ask-mq]'), (parseInt(d.getAttribute('data-i'), 10) || 0) + (e.key === 'ArrowRight' ? 1 : -1));
  });
})();
